/* © 2020 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, February 10, 2020
 * For information or permission request, email info@aetonixsystems.com
 */
var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedworkflowexternals",
	init: init,
	listeners: listeners,

	recalculate: recalculate,
	fetchForms: fetchForms
});

function init() {
	this.push({});
}


function listeners(){
	return {
		"manageddefinitionworkflow:updated": Model.makeRecalculator("definitions")
	};
}

function recalculate() {
	var definitions = this._definitions;

	var formIds = definitions.reduce(function(result, current){
		var schema = current.schema || {};
		var externals = current.externals || {};

		var externalSchema = schema.externals || {};

		Object.keys(externals).forEach(function(external){
			if(externalSchema[external] === "form")
				result = result.concat(externals[external]);
		});
		return result;
	}, []);

	if(formIds.length) this.fetchForms(formIds);

}

function fetchForms(ids){
	return this.api.forms.list.definitions(ids)
		.then(createMap.bind(this))
		.then(setWorkflows.bind(this))
		.catch(console.log.bind(console));
}

function createMap(results){
	return results.reduce(function(result, form){
		result[form._id] = form;
		return result;
	}, {});
}

function setWorkflows(formMap){
	var definitions = this._definitions;
	var reduced = definitions.reduce(function(result, workflow){
		var externals = workflow.externals || {};
		var workflowFormMap = Object.keys(externals).reduce(function(acc, external){
			acc[external] = (formMap[externals[external]] || {}).schema;
			return acc;
		}, {});

		result[workflow._id] =  workflowFormMap;
		return result;
	}, {});

	this.push(reduced);
}